// extracted by mini-css-extract-plugin
export default {"marker":"style_marker__xdSU3","container":"style_container__ZKVRW","title":"style_title__opR8s"};